import { 
    Center
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ErrorProps = {
    message?: string
}

export const Error = ({ message }: ErrorProps) => {
    const { t } = useTranslation();

    return (
        <Center style={{ height: '100%'}}>
            { message ?? t('error.error') }
        </Center>
    )
}